import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Company } from '../../models/company.model';
import { Settings } from '../../models/settings.model';
import { legendValid } from '../../tools/legend.data.entry.tool';
import { modalShow } from '../../tools/modal.tool';
import { suffixLegend } from '../../scripts/name.legend.script';

import AppLegend from './Legend';
import AppModalSettingCreateTax from '../modal/ModalSettingsCreateTax';

export interface AppInputRequirementTaxProps {
  companyForUser: Company,
  settingsForCompany: Settings,
  content: {value: any, index: number, sub_index: number},
  requirements: {list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]},
  setRequirements: Dispatch<SetStateAction<{list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]}>>,
  loadSettingsForCompany: Function
};

const AppInputRequirementTax: React.FunctionComponent<AppInputRequirementTaxProps> = ({companyForUser, settingsForCompany, content, requirements, setRequirements, loadSettingsForCompany}) => {
  const {lang} = StateLanguage()

  const handleChangeTaxRateContentToRequirement = (item: string) => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].tax_rate = item
      }
      return temp_item
    })
    let tempRequirementsValid = requirements.valid.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].tax_rate = true
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue, valid: tempRequirementsValid})
    legendValid(`legend-requirement-content-tax-required${suffixLegend(content.index, content.sub_index)}`)
  }

  const executeShowModalSettingsCreateTaxRate = () => {
    modalShow(`modal-settings-create-tax-rate${suffixLegend(content.index, content.sub_index)}`)
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select form-select-solid bg-light px-2" style={{backgroundImage: requirements.valid[content.index].contents[content.sub_index].tax_rate ? "none" : ""}}>
              <span className="select2-selection__rendered" role="textbox">
                {requirements.valid[content.index].contents[content.sub_index].tax_rate ? content.value.tax_rate : "\u00A0"}
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox">
                <li className="select2-results__option select2-results__option--selectable d-none">
                  <Dropdown.Item bsPrefix="select2-results__option__text" onClick={executeShowModalSettingsCreateTaxRate}>
                    <div className="d-flex align-items-center">
                      <span className="svg-icon svg-icon-3 me-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                          <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                          <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                        </svg>
                      </span>
                      {lang.labels.addTax}
                    </div>
                  </Dropdown.Item>
                </li>
                <li className={`select2-results__option select2-results__option--selectable ${settingsForCompany.tax_fees.length > 0 && "d-none"}`}>
                  <Dropdown.Item bsPrefix="select2-results__option__text">{lang.labels.selectOption}</Dropdown.Item>
                </li>
                { settingsForCompany.tax_fees.map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${item === content.value.tax_rate && "select2-results__option--selected"}`} role="option" aria-selected={item === content.value.tax_rate}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeTaxRateContentToRequirement(item)}>{item}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
      <AppLegend attribute={{check: requirements.valid[content.index].contents[content.sub_index].tax_rate, name: "requirement-content-tax", index: content.index, sub_index: content.sub_index}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
      <AppModalSettingCreateTax companyForUser={companyForUser} options={{main_modal: null, index: content.index, sub_index: content.sub_index}} requirements={requirements} setRequirements={setRequirements} loadSettingsForCompany={loadSettingsForCompany} />
    </>
  )
}

export default AppInputRequirementTax;
